var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutRedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 18,
    height: 21,
    rx: 4,
    fill: "#F95959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3532 10.9532C24.5484 10.7579 24.5484 10.4413 24.3532 10.2461L21.1712 7.06408C20.9759 6.86881 20.6593 6.86881 20.4641 7.06408C20.2688 7.25934 20.2688 7.57592 20.4641 7.77118L23.2925 10.5996L20.4641 13.428C20.2688 13.6233 20.2688 13.9399 20.4641 14.1351C20.6593 14.3304 20.9759 14.3304 21.1712 14.1351L24.3532 10.9532ZM9.59961 11.0996H23.9996V10.0996H9.59961V11.0996Z",
    fill: "#C40F0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutRedIcon);
export default __webpack_public_path__ + "static/media/logout-red-icon.7c88be11b4054a1dc2096819c1bbc3f7.svg";
export { ForwardRef as ReactComponent };